module.exports = __webpack_public_path__ + "static/media/tick.f3c8aef8.svg";